export default __webpack_public_path__ + "static/media/spit_sun_moon.451eaa52.png";